class ProductMedia extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initElements();
    this.initSlider();
    this.initThumbnailSlider();
    this.attachEvents();
  }

  attachEvents() {
    this.debouncedOnResize = debounce(() => {
      const isMobileDevices = window.matchMedia(this.mobileBreakpoint).matches;

      if (isMobileDevices && !this.slider) {
        this.initSlider();
        this.initThumbnailSlider();
      } else if (!isMobileDevices) {
        this.destroySlider();
        this.destroyThumbnailSlider();
      }
    }, 100);

    window.addEventListener('resize', this.debouncedOnResize.bind(this));
  }

  initElements() {
    this.mobileBreakpoint = '(max-width: 989px)';
    this.slider = null;
    this.thumbnailSlider = null;
    this.thumbnailOptions = {
      slidesPerView: 'auto',
      spaceBetween: 10,
      slideToClickedSlide: true,
      watchSlidesProgress: true,
    };
  }

  initSlider() {
    const isMobileDevices = window.matchMedia(this.mobileBreakpoint).matches;
    const sliderEl = this.querySelector('[data-slider]');

    if (!sliderEl || this.slider !== null || !isMobileDevices) return;

    // Initialize thumbnail slider first so it can be passed into main slider
    const thumbsSliderEl = this.querySelector('[data-thumbs-slider]');
    if (thumbsSliderEl && this.thumbnailSlider === null) {
      this.thumbnailSlider = new Swiper(thumbsSliderEl, this.thumbnailOptions);
    }

    this.slider = new Swiper(sliderEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      autoHeight: true,
      navigation: {
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev'),
      },
      pagination: {
        el: this.querySelector('.swiper-pagination'),
        type: 'fraction',
      },
      // Pass the thumbs swiper instance upfront in the config
      thumbs: {
        swiper: this.thumbnailSlider,
      },
    });
  }

  // initThumbnailSlider is now a no-op since it's handled inside initSlider
  // Kept for backwards compatibility if called externally
  initThumbnailSlider() {}

  destroySlider() {
    if (this.slider) {
      this.slider.destroy();
      this.slider = null;
    }
  }

  destroyThumbnailSlider() {
    if (this.thumbnailSlider) {
      this.thumbnailSlider.destroy();
      this.thumbnailSlider = null;
    }
  }
}

customElements.define('product-media', ProductMedia);
